import { ShoppingTypeFilterFilterdOptions } from "~/bff/types/ShoppingTypeFilterFilterdOptions";
import { ProductRequestType } from "~/types/products-request-handler";

export const getKeyByValue = (
  object: ShoppingTypeFilterFilterdOptions,
  value?: string,
): ProductRequestType => {
  return (Object.keys(object).find(
    (key) => object[key as keyof ShoppingTypeFilterFilterdOptions] === value,
  ) || "") as ProductRequestType;
};
